import {HomeIcon} from '@/components/common/icons/HomeIcon'
import {theme} from '@/theme/theme'
import {routeTo} from '@/utils/router'

import {getSuccessPageContent} from './successPageContent'

export const useSuccessPageContent = () => ({
  ...getSuccessPageContent(),
  imageSrc: '/images/email-sent.svg',
  imageAlt: 'Email sent',
  confirmationDescription: 'success-page-confirmation-description',
  nextStepsDescription: 'success-page-next-steps-description',
  spamDescription: 'success-page-spam-description',
  resendDescription: 'success-page-resend-description',
  homeButton: {
    icon: <HomeIcon color={theme.palette.background.default} />,
    linkText: 'button-back-to-homepage',
    linkHref: routeTo.home(),
  },
  accountActivation: {
    title: 'authentication.account-activation-title',
    description: 'authentication.account-activation-desc',
  },
  signUp: {
    title: 'authentication.signup-title',
    description: 'authentication.create-account-benefit',
    dropdownTitle: 'authentication.create-account-dropdown-title',
    buttonText: 'authentication.create-account-title',
    creatingTitle: 'authentication.creating-account-title',
    createdTitle: 'authentication.created-account-title',
  },
  reassuranceBanner: {
    salutationWithName: 'success-page-salutation',
    salutationWithoutName: 'success-page-salutation-without-name',
    linkHref: routeTo.blog.home(),
  },
  emailClients: [
    {
      imageSrc: '/images/email-clients/gmail.svg',
      imageAlt: 'Gmail',
      linkHref:
        'https://mail.google.com/mail/u/0/#search/from%3Atrademarks%40tramatm.com+in%3Aanywhere',
    },
    {
      imageSrc: '/images/email-clients/outlook.svg',
      imageAlt: 'Outlook',
      linkHref: 'https://outlook.live.com/mail/0/',
    },
    {
      imageSrc: '/images/email-clients/yahoo.svg',
      imageAlt: 'Yahoo',
      linkHref: 'https://mail.yahoo.com',
    },
    {
      imageSrc: '/images/email-clients/proton-mail.svg',
      imageAlt: 'Proton mail',
      linkHref: 'https://mail.proton.me',
    },
  ],
  emailNotReceivedDescription: 'success-email-not-received-desc',
  spamOrContactDescription: 'success-spam-desc',
})
